import type { PLAElementRecord } from "./PLAState";

export function getPLAElementData(element: PLAElementRecord): PLAElementRecord {
   const data = { ...element };
   // Table rows extend elements with transient __ fields, including calculated cubes.
   for (const key of Object.keys(data)) {
      if (key.startsWith("__")) Reflect.deleteProperty(data, key);
   }
   return data;
}
